function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj } from '@/services/base';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['customer_insights']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var MICROSERVICE = '/customer_insights';
var CONTROLLER_NAME = '/somos1';
var DOMAIN_REPORTS = '/reports';
var DOMAIN_CONFIGURATION = '/configuration';
var DOMAIN_ASSIGNMENTS = '/assignments';
export default {
  getReportsAssignments: function getReportsAssignments() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_ASSIGNMENTS).concat(DOMAIN_REPORTS, "/get_all"), body).then(function (response) {
      return response.data;
    });
  },
  getSomos1Reports: function getSomos1Reports() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_REPORTS, "/get_all"), body).then(function (response) {
      return response.data;
    });
  },
  getSomos1Report: function getSomos1Report(reportId) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_REPORTS, "/").concat(reportId), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  addSomos1Report: function addSomos1Report() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_REPORTS, "/add"), body).then(function (response) {
      return response.data;
    });
  },
  updateSomos1Report: function updateSomos1Report(reportId) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.put("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_REPORTS, "/").concat(reportId, "/update"), body).then(function (response) {
      return response.data;
    });
  },
  deleteSomos1Report: function deleteSomos1Report(reportId) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_REPORTS, "/").concat(reportId, "/delete"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  assignUserReport: function assignUserReport(reportId) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_ASSIGNMENTS).concat(DOMAIN_REPORTS, "/").concat(reportId, "/assign"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  updateUserReport: function updateUserReport(reportId) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_ASSIGNMENTS).concat(DOMAIN_REPORTS, "/").concat(reportId, "/update"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  revokeUserReport: function revokeUserReport(assignmentId) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_ASSIGNMENTS, "/").concat(assignmentId, "/users/revoke"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  somos1_agreement: function somos1_agreement() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_REPORTS, "/somos1_agreement"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postDownloadData: function postDownloadData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(DOMAIN_CONFIGURATION, "/download_users"), body, {
      responseType: 'blob'
    }).then(function (response) {
      return response;
    });
  },
  somos1_has_accepted_agreement: function somos1_has_accepted_agreement() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_REPORTS, "/has_accepted_agreement"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  updateDashboardDiccionary: function updateDashboardDiccionary(reportId) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.put("".concat(MICROSERVICE).concat(CONTROLLER_NAME).concat(DOMAIN_REPORTS, "/").concat(reportId, "/update_dashboard_dictionary"), body).then(function (response) {
      return response.data;
    });
  },
  getRegionalIndicatorsV2: function getRegionalIndicatorsV2() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var api_mock = appApisGTW.defaults.baseURL.includes('gtw-dp-b72612lc') ? '_mock' : '';
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME, "/data_entry_v2/regional_indicators") + api_mock, data).then(function (response) {
      return response.data;
    });
  },
  getRegionalIndicatorsYtdV2: function getRegionalIndicatorsYtdV2() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var api_mock = appApisGTW.defaults.baseURL.includes('gtw-dp-b72612lc') ? '_mock' : '';
    return appApisGTW.post("".concat(MICROSERVICE).concat(CONTROLLER_NAME, "/data_entry_v2/regional_indicators_ytd") + api_mock, data).then(function (response) {
      return response.data;
    });
  }
};